export const getOrganizedUnitFilter = state => state.organizedUnit.filter
